import Component from "../component.abstract";
import { EVENT_TRIGGER } from "./global-event";
import TrackEvent, { TrackEventProps } from "./track-event";

export interface ClickEventProps {
    [index: string]: any;
}

export default class ClickEvent extends Component {
    private trackEvent: TrackEvent;

    constructor (
        private props: ClickEventProps,
        element: HTMLElement
    ) {
        super(props, element);
    }

    mounted(): void {
        this.track();
    }

    track(): void {
        // Create a track event with adapted props
        this.trackEvent = new TrackEvent(this.getProps(), this.element);
        this.trackEvent.track();
    }

    update(data: any): void {
        if (data.list) {
            this.trackEvent.setList(data.list);
        }
    }

    /**
     * Create props for track event
     */
    getProps(): TrackEventProps {
        const trackProps: TrackEventProps = {
            "ecommerce": {
                "click": {
                    "actionField": {"list": "" },
                    "products": [{
                        "name": "",
                        "id": "",
                        "category":"",
                        "brand": "",
                        "variant": "",
                        "price": "",
                        "position": "",
                        "dimension74" : "",
                        "dimension77" : ""
                    }]
                }
            },
            "types" : ["gtm"],
            "trigger" : this.props.trigger || EVENT_TRIGGER.CLICK
        };

        let list: string;
        if (this.props.list) {
            list = this.props.list;
        } else {
            list = "LO-Moteur";
            if (document.querySelectorAll("[data-engine-facets]").length) {
                if (this.props.exclu && ((this.props.exclu + "").toLowerCase() === "true")) {
                    list += "-Exclusif";
                } else if (this.props.orange && (this.props.orange + "").toLowerCase() === "true") {
                    list += "-Approchant";
                } else {
                    list += "-Exact";
                }
            }
        }

        trackProps.ecommerce.click.actionField.list = list;
        for (let key in trackProps.ecommerce.click.products[0]) {
            if (this.props[key]) {
                trackProps.ecommerce.click.products[0][key] = this.props[key];
            }
        }

        return trackProps;
    }
}